export const ACCOUNT_STATUS_OPTIONS = [
  {
    text: 'Unknown',
    value: '-',
  },
  {
    text: 'Active',
    value: 'A',
  },
  {
    text: 'Blocked',
    value: 'BL',
  },
  {
    text: 'Closed',
    value: 'CL',
  },
  {
    text: 'Dormant',
    value: 'C',
  },
  {
    text: 'Inactive',
    value: 'B',
  },
  {
    text: 'Termination in Process',
    value: 'TP',
  },
] as const;

export type AccountStatus =
  | (typeof ACCOUNT_STATUS_OPTIONS)[number]['value']
  | '';
